import React, { useEffect, useState, useRef } from 'react'

import './ActivateAccount.css'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar'
import { InputMask } from 'primereact/inputmask';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

import ReCAPTCHA from "react-google-recaptcha";
import check from '../../../images/check.jpg'
import { useSelector, useDispatch } from 'react-redux'
import { updateAccountActivateData, checkAccountActivationStatus } from '../../../actions'
import { Messages } from 'primereact/messages';
import environment from '../../../environment';
import moment from 'moment'
const GetStart = (props) => {

  const [backurl, setBackUrl] = useState(null)
  const [showCheck, setShowCheck] = useState(false)
  const dispatch = useDispatch()
  const accountActivateData = useSelector(state => state.accountActivateReducers)
  const [requestingCheckActivation, setRequestingCheckActivation] = useState(false)
  const [invalid, setInvalid] = useState({
    refnum: false,
    firstname: false,
    lastname: false,
    dob: false,
    dobFuture:false,
    ssn: false,
    ssn_min_length: false
  })

  const resetValidation = (fields) => {
    var fieldsUpdate = {}
    if (typeof (fields) === 'string') {
      fieldsUpdate[`${fields}`] = false
    } else if (Array.isArray(fields)) {
      fields.forEach((item => {
        fieldsUpdate[`${item}`] = false
      }))
    }
    setInvalid(Object.assign({}, invalid, fieldsUpdate))
  }

  const validateOnSubmit = () => {
    var allowSubmit = true;
    var invalidJSON = {}
    if (props.validateRecapt === null) {
      props.setRequiredRecaptcha(true)
      allowSubmit = false;
    }
    if (accountActivateData.data.ssn === null) {
      Object.assign(invalidJSON, { ssn: true })
      allowSubmit = false
    } else {
      if (accountActivateData.data.ssn.length < 4) {
        Object.assign(invalidJSON, { ssn_min_length: true })
        allowSubmit = false
      }
    }

    if (accountActivateData.data.refnum === null) {
      Object.assign(invalidJSON, { refnum: true })
      allowSubmit = false
    }

    if (accountActivateData.data.firstname === null) {
      Object.assign(invalidJSON, { firstname: true })
      allowSubmit = false
    }

    if (accountActivateData.data.lastname === null) {
      Object.assign(invalidJSON, { lastname: true })
      allowSubmit = false
    }

    if (accountActivateData.data.dob === null) {
      Object.assign(invalidJSON, { dob: true })
      allowSubmit = false
    }else{
      if(moment(new Date(accountActivateData.data.dob)).isAfter(moment(new Date()).subtract(1,'days'))){
      Object.assign(invalidJSON, { dobFuture: true })
      allowSubmit = false
      }
    }

    if (allowSubmit) {
      //check activation status
      //props.setActiveIndex(1)
      dispatch(checkAccountActivationStatus(Object.assign({}, {}, accountActivateData.data)))
      setRequestingCheckActivation(true)
    } else {
      setInvalid(Object.assign({}, invalid, invalidJSON))
    }
  }

  const messages = useRef(null)
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (requestingCheckActivation && accountActivateData.requesting_check_activation_successful) {
      props.setActiveIndex(1)
      setRequestingCheckActivation(false)
    }
    if (requestingCheckActivation && accountActivateData.message !== null) {
      if (accountActivateData.infoError !== null) {
        messages.current.show({ severity: 'info', summary: "", detail: accountActivateData.message, sticky: true });
      } else if (accountActivateData.message !== null) {
        props.toast.current.show({ severity: 'error', summary: "Search User API", detail: accountActivateData.message, sticky: true });
      }
      setRequestingCheckActivation(false)
    }

  })

  useEffect(() => {

    const queryParams = new URLSearchParams(window.location.search)
    const backbtnurl = queryParams.get("backbtnurl")
    const loginparam = queryParams.get("login")
          if (backbtnurl !== null && backbtnurl !== '') { 
            setBackUrl(`${backbtnurl.replace('/login.html','')}/oauth2/authorization/oracle`)
    }
  }, [])

  return <div>

    <div className="activate-account-card">
      <div className="center">

        <div className="big-title">Activate Account</div>
        <div className="sub-title">To setup your account, we need to locate you in our system.</div>
        <Messages ref={messages}></Messages>
        <div className="row-container">
          {showCheck ? <div className="check-container"><img src={check} alt="check" /></div> : null}
          <div className="label">Reference Number</div> 
          <div>
            <InputText value={accountActivateData.data.refnum || ''} onChange={(e) => {
              resetValidation('refnum')
              dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { refnum: e.target.value !== '' ? e.target.value : null })))
            }} />
          </div>
          <div><span className="need-help" onClick={() => {
            setShowCheck(!showCheck)
          }}>(Need help finding your ID Number?)</span></div>
          {invalid.refnum ? <small> <div className="p-error top-margin">Reference number is required</div></small> : null}
        </div>

        <div className="row-container">
          <div className="label">First Name</div>
          <div>
            <InputText value={accountActivateData.data.firstname || ''} onChange={(e) => {
              resetValidation('firstname')
              dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { firstname: e.target.value })))
            }} />
          </div>
          {invalid.firstname ? <small> <div className="p-error top-margin">First name is required</div></small> : null}
        </div>

        <div className="row-container">
          <div className="label">Last Name</div>
          <div>
            <InputText value={accountActivateData.data.lastname || ''} onChange={(e) => {
              resetValidation('lastname')
              dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { lastname: e.target.value })))
            }} />

          </div>
          {invalid.lastname ? <small> <div className="p-error top-margin">Last name is required</div></small> : null}
        </div>

        <div className="row-container">
          <div className="label">Date of Birth</div>
          <div>
            {/* <Calendar value={accountActivateData.data.dob || ''} onChange={(e) => {
              resetValidation(['dob','dobFuture'])
              dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { dob: e.value })))
            }} mask="99/99/9999" yearRange={`${moment(new Date()).subtract(100, 'years').format('YYYY')}:${moment(new Date()).format('YYYY')}`} yearNavigator monthNavigator /> */}
            <InputMask mask="99/99/9999" slotChar="mm/dd/yyyy" value={accountActivateData.data.dob || ''} onChange={(e) => {
                resetValidation(['dob','dobFuture'])
                dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { dob: e.value })))
            }}></InputMask>
          </div>
          {invalid.dob ? <small> <div className="p-error top-margin">Date of birth is required</div></small> : null}
          {invalid.dobFuture ? <small> <div className="p-error top-margin">Date of birth cannot be future date.</div></small> : null}
        </div>

        <div className="row-container">
          <div className="label">Last 4 SSN</div>
          <div>
            <InputText value={accountActivateData.data.ssn || ''} onChange={(e) => {
              if (e.target.value.length > 4) {
                return
              }
              resetValidation(['ssn', 'ssn_min_length'])
              dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { ssn: e.target.value !== '' ? e.target.value.replace(/[^\d]/g, '') : null })))
            }} />
          </div>
          {invalid.ssn ? <small> <div className="p-error top-margin">Last 4 digits of SSN is required</div></small> : null}
          {invalid.ssn_min_length ? <small> <div className="p-error top-margin">SSN has to be 4 digits</div></small> : null}
        </div>


        <div className="recapt">

          <ReCAPTCHA
            sitekey={environment.google_site_key}
            onChange={(value) => {
              if (value) {
                props.setValidateRecapt(value)
                props.setRequiredRecaptcha(false)
              }
            }}
          />

          {props.requiredRecaptcha ? <small><div className="error p-error">Recaptcha is required</div></small> : <div className="error-placeholder">&nbsp;&nbsp;</div>}

        </div>

        <div className="row-container">
          <Button disabled={requestingCheckActivation} onClick={() => {
            if(requestingCheckActivation){
              return
            }
            validateOnSubmit()
          }}>{requestingCheckActivation ? <i className="pi pi-spin pi-spinner"></i>:<span>&nbsp;&nbsp;</span>}&nbsp;&nbsp;Get Started</Button>
        </div>

        {/* {backurl ? <div className="row-btn">
          <span className="row-btn-link"><a href={backurl}>Back</a></span>
        </div> : null} */}

        {/* <div className="row-btn">
          <span className="row-btn-link">Need help? Check out our FAQs</span>
        </div> */}

        {backurl ? 
         <div className="already-activate row-btn">
          <span>Already activated?</span> <span><a href={backurl}><span className="row-btn-link">Sign in <FontAwesomeIcon icon={faCaretRight} /></span></a></span>
        </div> 
        :<div className="already-activate row-btn">
          <span>Already activated?</span> <span><a href={props.defaultLoginURL}><span className="row-btn-link">Sign in <FontAwesomeIcon icon={faCaretRight} /></span></a></span>
        </div> 
        }

        <div className="space-holder"></div>
      </div>
    </div>
  </div >

}

export default GetStart